module.exports = __webpack_public_path__ + "img/4-top.8df8db80.png";